import { Dropdown, Space } from 'antd';
import React, { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Menu } from 'components/atoms/dropdown';
import {
  DateField,
  SingleSelectField,
  SingleUserField,
} from 'components/organisms/tasks/fields';

type Field = SingleSelectField | SingleUserField | DateField;
interface GroupByMenuProps {
  groupByKey: string;
  onChange: (fieldName: string) => void;
  disabled?: boolean;
  fields?: Field[];
}

const StyledMenu = styled(Menu)`
  max-height: 45vh;
  height: 100%;
  overflow: scroll;
`;

export const GroupByMenu: FC<GroupByMenuProps> = ({
  groupByKey,
  onChange,
  disabled = false,
  fields = [],
}) => {
  const handleOnSelect = ({ key }) => {
    if (key) {
      onChange(key);
    }
  };

  const selected = useMemo(() => {
    return fields.find((field) => {
      return field.fieldName === groupByKey;
    });
  }, [groupByKey, fields]);

  return (
    <Dropdown
      disabled={disabled}
      trigger={['click']}
      overlay={
        <StyledMenu data-cy="views.list-all-views" selectedKeys={[groupByKey]}>
          <Menu.Header>
            <FormattedMessage id="group_by" />
          </Menu.Header>
          {fields.map(({ fieldName, fieldLabel }) => (
            <Menu.Item
              key={fieldName}
              onClick={handleOnSelect}
              data-cy={`pl-group-by-${fieldName}`}
            >
              {fieldLabel || fieldName}
            </Menu.Item>
          ))}
        </StyledMenu>
      }
    >
      <Button
        disabled={disabled}
        size="small"
        type="text"
        data-cy="pl-group-trigger"
      >
        <Space size="small">
          <div>
            <FormattedMessage id="group_by" />:
          </div>
          <strong data-cy="pl-group-selected">{selected?.fieldLabel}</strong>
        </Space>
      </Button>
    </Dropdown>
  );
};
